<div>
  <!-- Week navigation -->
  <div class="d-flex flex-column flex-md-row align-items-center justify-content-center gap-2 mb-3">
    <div class="d-flex align-items-center border rounded px-2 py-1 bg-white shadow-sm">
      <button class="btn btn-link p-0 text-primary" [disabled]="isPrevBtnDisabled" (click)="prevWeek()">
        <i class="bi bi-chevron-left"></i>
      </button>
      <i class="bi bi-calendar mx-2"></i>
      <button class="btn btn-link p-0 text-primary" [disabled]="isNextBtnDisabled" (click)="nextWeek()">
        <i class="bi bi-chevron-right"></i>
      </button>
    </div>
    <div class="fw-semibold">{{ weekStart | date: 'dd MMM yyyy' }} - {{ weekEnd | date: 'dd MMM yyyy' }}</div>
  </div>

  <!-- Attendance Table -->
  <div class="table-responsive bg-white">
    <table class="table table-bordered align-middle mb-0">
      <thead class="table-light">
        <tr>
          <th class="text-center">Date</th>
          <th class="text-center">Day</th>
          <th class="text-center">First Check-in</th>
          <th class="text-center">Last Check-out</th>
          <th class="text-center">Total Hours</th>
          <th class="text-center">Remarks</th>
          <th class="text-center">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let day of weeklyData">
          <!-- Date -->
          <td class="text-center">{{ day.date | date: 'dd MMM yyyy' }}</td>
          <!-- Day -->
          <td class="text-center">{{ day.date | date: 'EEE' }}</td>
          <!-- Check-in -->
          <td class="text-center">
            <ng-container *ngIf="!day.isWeekend && day.firstCheckIn; else noCheckIn">
              {{ day.firstCheckIn | date: 'hh:mm a' }}
            </ng-container>
            <ng-template #noCheckIn>
              <span class="text-muted">-</span>
            </ng-template>
          </td>

          <!-- Check-out -->
          <td class="text-center">
            <ng-container *ngIf="!day.isWeekend && day.lastCheckOut; else noCheckOut">
              {{ day.lastCheckOut | date: 'hh:mm a' }}
            </ng-container>
            <ng-template #noCheckOut>
              <span class="text-muted">-</span>
            </ng-template>
          </td>

          <!-- Total Hours -->
          <td class="text-center">
            {{ day.isWeekend || !day.logs?.length ? '00:00' : day.total_worked_hours }}
          </td>
          <!-- Remarks -->
          <td class="text-center">
            <ng-container *ngIf="day.isWeekend">
              <span class="app-badge badge-warning">Weekend</span>
            </ng-container>
            <ng-container *ngIf="!day.isWeekend && (!day.logs || day.logs.length === 0)">
              <span class="app-badge badge-danger">Absent</span>
            </ng-container>
            <ng-container *ngIf="!day.isWeekend && (day.logs || []).length > 0">
              <span class="app-badge badge-success">Present</span>
            </ng-container>
          </td>

          <td class="text-center">
            @if (!day.logs || (day.logs || []).length === 0) {
              <span>-</span>
            } @else {
              <button class="btn btn-action-info" (click)="openLogsModal(day, logsModal)">
                <i class="bi bi-eye"></i>
              </button>
            }
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<ng-template #logsModal let-modal>
  <div class="modal-content border-0 shadow-lg">
    <div class="modal-header">
      <h5 class="modal-title">Attendance Details — {{ selectedDay?.date | date: 'fullDate' }}</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>

    <div class="modal-body p-0">
      <div *ngIf="selectedDay?.logs?.length; else noLogs">
        <!-- Check-in / Check-out playback -->
        <div class="card border m-3">
          <div class="card-header">
            <i class="bi bi-map me-2"></i>
            Route / Location Playback
          </div>
          <div class="card-body p-0">
            @if (hasMapData) {
              <google-map
                height="320px"
                width="100%"
                [center]="mapCenter"
                [zoom]="zoom"
                (mapInitialized)="onMapInitialized($event)">
                <map-marker
                  #ciMarker="mapMarker"
                  *ngFor="let m of checkInMarkers"
                  [position]="m.position"
                  [label]="m.label"
                  [title]="'Check-in: ' + m.label"
                  (mapMouseover)="onMarkerHover(logsInfoWindow, ciMarker, m, 'check-in')"
                  (mapMouseout)="onMarkerOut(logsInfoWindow)"></map-marker>
                <map-marker
                  #coMarker="mapMarker"
                  *ngFor="let m of checkOutMarkers"
                  [position]="m.position"
                  [label]="m.label"
                  [title]="'Check-out: ' + m.label"
                  (mapMouseover)="onMarkerHover(logsInfoWindow, coMarker, m, 'check-out')"
                  (mapMouseout)="onMarkerOut(logsInfoWindow)"></map-marker>
                <map-polyline
                  *ngFor="let path of sessionPaths"
                  [path]="path"
                  [options]="{ strokeColor: '#4285F4', strokeWeight: 3, strokeOpacity: 0.8 }"></map-polyline>
                <map-polyline
                  *ngFor="let path of travelPaths"
                  [path]="path"
                  [options]="{ strokeColor: '#fd7e14', strokeWeight: 2, strokeOpacity: 0.7 }"></map-polyline>
                <map-info-window #logsInfoWindow="mapInfoWindow">
                  @if (activeMarkerInfo) {
                    <div style="font-size: 0.8rem; min-width: 160px; line-height: 1.6">
                      <div class="fw-semibold mb-1">
                        <span [style.color]="activeMarkerInfo.type === 'check-in' ? '#198754' : '#0dcaf0'">
                          {{ activeMarkerInfo.type === 'check-in' ? '▶ Check-in' : '◼ Check-out' }}
                        </span>
                        &nbsp;·&nbsp;{{ activeMarkerInfo.label }}
                      </div>
                      <div>🕐 {{ activeMarkerInfo.time | date: 'hh:mm a' }}</div>
                      @if (activeMarkerInfo.address) {
                        <div style="color: #6c757d; margin-top: 2px">📍 {{ activeMarkerInfo.address }}</div>
                      }
                    </div>
                  }
                </map-info-window>
              </google-map>
            } @else {
              <div class="text-center py-4 text-muted">
                <i class="bi bi-geo-alt display-6"></i>
                <p class="mt-2 mb-0">No location data available.</p>
              </div>
            }
          </div>
        </div>

        <div *ngFor="let log of selectedDay.logs; let i = index" class="card mb-3 border-0 bg-light bg-opacity-50">
          <div class="card-header bg-transparent border-0 pt-3">
            <h6 class="mb-0 fw-bold">
              Session {{ i + 1 }}
              <span class="text-muted small">({{ log.tour_purpose }})</span>
            </h6>
          </div>

          <div class="card-body">
            <div class="row g-4">
              <div class="col-md-6">
                <div class="d-flex flex-column gap-1">
                  <span
                    class="text-muted small fw-bold text-uppercase"
                    style="font-size: 0.65rem; letter-spacing: 0.05em">
                    Check-in
                  </span>
                  <span class="fw-medium text-primary">{{ log.check_in | date: 'hh:mm a' }}</span>
                  <span class="small text-muted">
                    <i class="bi bi-geo-alt me-1"></i>
                    {{ log.check_in_location?.address }}
                  </span>
                  <img
                    *ngIf="log.check_in_image"
                    [src]="log.check_in_image"
                    class="rounded mt-2 border shadow-sm"
                    style="width: 100px; height: 100px; object-fit: cover" />
                </div>
              </div>

              <div class="col-md-6">
                <div class="d-flex flex-column gap-1">
                  <span
                    class="text-muted small fw-bold text-uppercase"
                    style="font-size: 0.65rem; letter-spacing: 0.05em">
                    Check-out
                  </span>
                  <span class="fw-medium text-primary">
                    {{ log.check_out ? (log.check_out | date: 'hh:mm a') : '—' }}
                  </span>
                  <span class="small text-muted">
                    <i class="bi bi-geo-alt me-1"></i>
                    {{ log.check_out_location?.address || '—' }}
                  </span>
                  <img
                    *ngIf="log.check_out_image"
                    [src]="log.check_out_image"
                    class="rounded mt-2 border shadow-sm"
                    style="width: 100px; height: 100px; object-fit: cover" />
                </div>
              </div>

              <div class="col-12 mt-2">
                <div class="p-3 bg-white rounded border d-flex flex-wrap gap-4">
                  <div>
                    <div class="text-muted fw-bold text-uppercase" style="font-size: 0.6rem; letter-spacing: 0.05em">
                      Tour Type
                    </div>
                    <div class="small fw-medium">{{ log.tour_type }}</div>
                  </div>
                  <div>
                    <div class="text-muted fw-bold text-uppercase" style="font-size: 0.6rem; letter-spacing: 0.05em">
                      Vehicle
                    </div>
                    <div class="small fw-medium">{{ log.vehicle_type }}</div>
                  </div>
                  <div>
                    <div class="text-muted fw-bold text-uppercase" style="font-size: 0.6rem; letter-spacing: 0.05em">
                      KMs Tracked
                    </div>
                    <div class="small fw-medium">{{ log.opening_km }} → {{ log.closing_km || '—' }}</div>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="log.party_visits?.length" class="mt-4">
              <h6
                class="small fw-bold text-muted mb-3 text-uppercase"
                style="font-size: 0.65rem; letter-spacing: 0.05em">
                Party Visits
              </h6>
              <div class="table-responsive border rounded">
                <table class="table table-sm mb-0">
                  <thead class="bg-light">
                    <tr>
                      <th class="ps-3 py-2 small">Dealer / Shop</th>
                      <th class="py-2 small">Status</th>
                      <th class="py-2 small">Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let pv of log.party_visits">
                      <td class="ps-3 py-2">
                        <div class="fw-medium small">{{ pv.dealer?.shop_name }}</div>
                        <div class="text-muted" style="font-size: 0.7rem">
                          {{ pv.dealer?.first_name }} {{ pv.dealer?.last_name }}
                        </div>
                      </td>
                      <td class="py-2">
                        <span
                          class="app-badge"
                          [ngClass]="pv.visit_status === 'Completed' ? 'badge-soft-success' : 'badge-soft-warning'">
                          {{ pv.visit_status }}
                        </span>
                      </td>
                      <td class="py-2 small text-muted">
                        {{ pv.visit_remarks || pv.cancel_reason_display || '—' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ng-template #noLogs>
        <div class="text-center py-5">
          <i class="bi bi-calendar-x text-muted display-4"></i>
          <p class="text-muted mt-3">No logs recorded for this date.</p>
        </div>
      </ng-template>
    </div>
  </div>
</ng-template>
